<div class="login-page min-h-screen w-screen flex items-center justify-center bg-gradient-to-r from-[#c9d6ff00] to-[#c9d6ff] p-4">
  <div class="card bg-base-100 shadow-xl w-full max-w-3xl">
    <div class="card-body flex-row items-center gap-8 p-8">
      <div class="flex-1 flex flex-col items-center text-center gap-1">
        <h2 class="text-xl font-semibold opacity-80">{{ 'SIGN_IN' | translate }}</h2>
        <p class="text-sm opacity-60 mb-4">{{ 'SIGN_IN_MESSAGE' | translate }}</p>

        <form (ngSubmit)="login()" [formGroup]="loginForm" class="w-full max-w-xs flex flex-col gap-4 text-left">
          <div class="flex flex-col gap-1">
            <span class="text-sm font-medium">{{ 'USERNAME' | translate }}</span>
            <input formControlName="email" type="text" class="input w-full" />
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-sm font-medium">{{ 'PASSWORD' | translate }}</span>
            <div class="relative">
              <input
                formControlName="password"
                [type]="hidePassword ? 'password' : 'text'"
                required
                class="input w-full pr-10"
                />
              <button
                type="button"
                class="absolute right-2 top-1/2 -translate-y-1/2 btn btn-ghost btn-xs btn-circle"
                aria-label="Toggle password visibility"
                (click)="hidePassword = !hidePassword"
                >
                <span class="material-icons-outlined text-base">{{ hidePassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>
          </div>

          @if (loginMessage) {
            <p class="text-error text-sm text-center">{{ loginMessage }}</p>
          }

          <button type="submit" class="btn btn-primary rounded-full mt-2" [disabled]="!loginForm.valid || showSpinner">
            @if (showSpinner) {
              <span class="loading loading-spinner loading-sm"></span>
            } @else {
              {{ 'SIGN_IN' | translate }}
            }
          </button>
        </form>
      </div>

      <div class="flex-1 hidden sm:flex items-center justify-center">
        <img src="assets/images/logo-mua-192x192.png" alt="Logo" class="max-w-[200px]" />
      </div>
    </div>
  </div>
</div>
